import React, { useState } from 'react';
import { Chrome } from 'lucide-react';
import { oauthProviders } from '../../lib/oauth';

interface OAuthConnectProps {
  onSuccess: () => void;
  onError: (error: string) => void;
}

export function OAuthConnect({ onSuccess, onError }: OAuthConnectProps) {
  const [connecting, setConnecting] = useState(false);

  const handleConnect = async (provider: 'google' | 'microsoft' | 'apple') => {
    try {
      setConnecting(true);
      // Add user agent to state parameter
      const state = btoa(JSON.stringify({
        returnTo: window.location.pathname,
        userAgent: navigator.userAgent
      }));
      sessionStorage.setItem('oauth_state', state);
      oauthProviders[provider].authorize();
    } catch (error) {
      console.error('OAuth connection failed:', error);
      onError('Failed to connect calendar. Please try again.');
    } finally {
      setConnecting(false);
    }
  };

  return (
    <div className="space-y-4">
      <button
        onClick={() => handleConnect('google')}
        disabled={connecting}
        className="flex items-center justify-center gap-2 w-full p-3 bg-white text-black rounded-xl hover:opacity-90 transition-opacity disabled:opacity-50"
      >
        <Chrome className="w-5 h-5" />
        <span>Connect Google Calendar</span>
      </button>
    </div>
  );
}